import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge, Card, EmptyState } from '@/components/ui';
import { ROLE_LABELS } from '@/features/auth/roles';
import { PAGES, rolesForPage, type PageId } from '@/features/navigation/pages';
import { PageContainer } from '@/layouts/PageContainer';

/** Shell for every Admin v2 page not built yet; lists the roles that use it. */
export function PlaceholderPage({ pageId }: { pageId: PageId }) {
  const { t } = useTranslation();
  const page = PAGES[pageId];
  return (
    <PageContainer>
      <Card
        title={page.label}
        actions={
          page.task ? (
            <Badge tone="info">{page.task}</Badge>
          ) : (
            <Badge>Later</Badge>
          )
        }
      >
        <EmptyState
          icon={<Construction size={22} />}
          title={t('empty.placeholderTitle', { page: page.label })}
          body={
            <>
              {t('empty.placeholderBody')}
              <br />
              Used by:{' '}
              {rolesForPage(pageId)
                .map((r) => ROLE_LABELS[r])
                .join(', ')}
              .
            </>
          }
        />
      </Card>
    </PageContainer>
  );
}
